import { render, staticRenderFns } from "./modification-form.vue?vue&type=template&id=359bd3fb&"
import script from "./modification-form.vue?vue&type=script&lang=js&"
export * from "./modification-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports